import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

export const HideOnMobile = styled.div`
  ${media.smallOnly`display: none;`}
`;

export const HideOnDesktop = styled.div`
  ${media.mediumUp`display: none;`}
`;

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
  margin-right: ${layout.spacing.xSmall};
`;

export const HomeDeliveryIcon = styled.img`
  min-height: 20px;
  min-width: 20px;
  height: 20px;
  width: 20px;
  display: block;
`;
